module.exports = __webpack_public_path__ + "media/images/Collection_Loading_transparent-5e5942a0.gif";